import { captureMessage, captureException } from '@sentry/react';

export const captureExceptionInProd = (error, context = null) => {
  captureException(error, context);

  // if (process.env.NODE_ENV === 'production') {
  //   captureException(error, context);
  // }
};

export const captureMessageInProd = (message) => {
  if (process.env.NODE_ENV === 'production') {
    captureMessage(message);
  }
};


